const EXTERNAL_EMAIL_DETAILS = 'This is an external email. Do not click on links or download attachments unless you trust the sender, know the content is safe, and were expecting this email.';

export function generateSeljanHtmlEmail(title: string, message: string): string {
    return `<!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <meta name="x-apple-disable-message-reformatting">

  <title>Seljan Company Notification</title>
</head>

<body style="
  margin: 0;
  padding: 0;
  background-color: #f3f4f6;
  font-family: Arial, Helvetica, sans-serif;
  color: #1f2937;
">

  <div style="
    display: none;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    color: transparent;
    line-height: 1px;
    font-size: 1px;
  ">
    ${message}
  </div>

  <table
    role="presentation"
    width="100%"
    cellspacing="0"
    cellpadding="0"
    border="0"
    style="width: 100%; background-color: #f3f4f6;"
  >
    <tr>
      <td align="center" style="padding: 30px 15px;">

        <table
          role="presentation"
          width="600"
          cellspacing="0"
          cellpadding="0"
          border="0"
          style="
            width: 100%;
            max-width: 600px;
            background-color: #ffffff;
            border-collapse: collapse;
            border: 1px solid #dfe3e8;
          "
        >

          <tr>
            <td style="
              padding: 24px 30px;
              background-color: #1f3a5f;
              color: #ffffff;
            ">
              <div style="
                margin: 0;
                font-size: 24px;
                line-height: 30px;
                font-weight: bold;
              ">
                Seljan Company
              </div>

              <div style="
                margin-top: 4px;
                font-size: 13px;
                line-height: 20px;
                color: #dbe7f5;
              ">
                Automated Notification
              </div>
            </td>
          </tr>

          <tr>
            <td style="
              padding: 12px 30px;
              background-color: #eef3f8;
              border-bottom: 1px solid #dfe3e8;
              font-size: 13px;
              line-height: 19px;
              color: #4b5563;
            ">
              This is an automated message from Seljan Company. Please do not reply to this email.
            </td>
          </tr>

          <tr>
            <td style="padding: 32px 30px;">

              <h1 style="
                margin: 0 0 18px 0;
                font-size: 24px;
                line-height: 32px;
                font-weight: bold;
                color: #111827;
              ">
                ${title}
              </h1>

              <p style="
                margin: 0 0 18px 0;
                font-size: 15px;
                line-height: 24px;
                color: #374151;
              ">
                Hello,
              </p>

              <p style="
                margin: 0 0 20px 0;
                font-size: 15px;
                line-height: 24px;
                color: #374151;
              ">
                ${message}
              </p>

              <table
                role="presentation"
                width="100%"
                cellspacing="0"
                cellpadding="0"
                border="0"
                style="
                  width: 100%;
                  margin: 24px 0;
                  background-color: #f8fafc;
                  border: 1px solid #dfe3e8;
                  border-collapse: collapse;
                "
              >
                <tr>
                  <td style="
                    padding: 18px 20px;
                    font-size: 14px;
                    line-height: 22px;
                    color: #374151;
                  ">
                    ${EXTERNAL_EMAIL_DETAILS}
                  </td>
                </tr>
              </table>

              <p style="
                margin: 28px 0 0 0;
                font-size: 15px;
                line-height: 24px;
                color: #374151;
              ">
                Thank you,<br>
                <strong>Seljan Company</strong>
              </p>

            </td>
          </tr>

          <tr>
            <td style="
              padding: 22px 30px;
              background-color: #f8fafc;
              border-top: 1px solid #dfe3e8;
              font-size: 12px;
              line-height: 19px;
              color: #6b7280;
            ">
              This email was sent automatically by a Seljan Company system.
              Replies to this address are not monitored.
              <br><br>

              For assistance, contact us at
              <a
                href="tel:9206482833"
                style="color: #1f3a5f; text-decoration: underline;"
              >
                920-648-2833</a>.
              <br><br>

              &copy; 2026 Seljan Company. All rights reserved.
            </td>
          </tr>

        </table>

      </td>
    </tr>
  </table>

</body>
</html>`;
}
